
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punebushireonlinebooking() {



    const cardData =
    {
        keyword: 'Pune Bus hire Online Booking Service  ',
        heading: 'Amruta Travels: Pune Bus hire Online Booking Service',
        headingDescription: 'Amruta Travels offers Pune Bus Hire Online Booking Service, making group travel easier, faster, and more convenient than ever before. Whether you are planning a corporate outing, wedding transportation, school trip, or family tour, our online platform allows you to book well-maintained buses in just a few clicks. Choose from a wide range of AC and non-AC buses, including 25-seater, 35-seater, 40-seater, and 50-seater options to suit your group size. With 24/7 customer support, transparent pricing, and professional drivers, Amruta Travels ensures a smooth and stress-free travel experience. Book your Pune bus rental online today with Amruta Travels and travel in comfort and confidence!',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Located approximately 66 km from Pune, these twin hill stations are nestled in the Sahyadri ranges. Known for their lush green valleys, waterfalls, and pleasant climate, they offer attractions like Bhushi Dam, Tiger's Leap, and Rajmachi Fort. Adventure enthusiasts can indulge in trekking, camping, and paragliding activities."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description": "Situated about 120 km from Pune, Mahabaleshwar is renowned for its strawberry farms, scenic viewpoints like Arthur's Seat, and the serene Venna Lake. Nearby Panchgani, at a distance of 100 km, offers attractions like Table Land and Parsi Point. Both hill stations provide a refreshing escape from city life."
  },
  {
    "title": "Matheran",
    "description": "Approximately 120 km from Pune, Matheran is India's smallest hill station and is unique for being a vehicle-free zone. Perched at an elevation of 800 meters, it offers panoramic views, colonial architecture, and 38 designated viewpoints, including Panorama Point and Louisa Point."
  },
  {
    "title": "Alibaug",
    "description": "Located around 140 km from Pune, Alibaug is a coastal town known for its clean beaches like Alibaug Beach and Nagaon Beach, as well as historical sites like Kolaba Fort. It's a popular destination for beach lovers and those seeking a tranquil seaside retreat."
  },
  {
    "title": "Kolad",
    "description": "Approximately 110 km from Pune, Kolad is famed for white-water rafting on the Kundalika River. The town also offers opportunities for kayaking, zip-lining, and camping, making it a haven for adventure seekers."
  },
  {
    "title": "Igatpuri",
    "description": "Situated about 240 km from Pune, Igatpuri is a hill station in the Western Ghats known for its misty mountains, waterfalls, and the Vipassana International Academy. It's an ideal spot for meditation, trekking, and enjoying nature's tranquility."
  },
  {
    "title": "Bhandardara",
    "description": "Located roughly 170 km from Pune, Bhandardara is a serene village offering attractions like the Bhandardara Lake, Randha Falls, and the historic Ratangad Fort. It's a perfect destination for nature lovers and those seeking solitude."
  },
  {
    "title": "Lavasa",
    "description": "Approximately 60 km from Pune, Lavasa is a planned city inspired by the Italian town of Portofino. It offers picturesque landscapes, water sports, and a range of dining options, making it a popular spot for weekend retreats."
  },
  {
    "title": "Goa",
    "description": "Situated about 450 km from Pune, Goa is India's premier beach destination. Known for its vibrant nightlife, Portuguese heritage, and sandy beaches like Baga and Anjuna, it offers a mix of relaxation and entertainment."
  },
  {
    "title": "Kaas Plateau",
    "description": "Around 140 km from Pune, the Kaas Plateau, also known as the 'Valley of Flowers of Maharashtra,' is a UNESCO World Natural Heritage site. During the monsoon season, it blooms with a variety of endemic flowers, attracting nature enthusiasts and photographers."
  }
],


   "services": [
    {
      "name": "Pune Bus Hire Online Booking for Outstation",
      "description": "Amruta Travels offers easy online bus hire services in Pune for outstation trips. Whether you're planning a family getaway or a corporate retreat, our online booking platform ensures a hassle-free travel experience."
    },
    {
      "name": "Online Bus Rental Pune",
      "description": "Book buses online in Pune with Amruta Travels for group trips, tours, events, and more. Choose from a fleet of Bharat Benz and luxury coaches for convenient travel planning."
    },
    {
      "name": "Hire a Bus Online Pune",
      "description": "Amruta Travels allows you to hire a bus online in Pune in just a few clicks. Select from various seating capacities and amenities for weddings, school trips, and business events."
    },
    {
      "name": "Online Bus Booking Pune",
      "description": "Enjoy seamless online bus booking in Pune with Amruta Travels. Reserve your preferred bus type instantly and travel stress-free for local and outstation journeys."
    },
    {
      "name": "Bus Rental Booking Pune",
      "description": "Make bus rental bookings in Pune easily with Amruta Travels. Choose from AC, non-AC, sleeper, and mini buses to suit your travel needs, all bookable online."
    },
    {
      "name": "Easy Bus Hire Online Pune",
      "description": "Experience easy bus hiring in Pune with Amruta Travels’ online platform. Designed for user-friendliness, it offers quick booking for any occasion or group size."
    },
    {
      "name": "Quick Bus Rental Booking Pune",
      "description": "Get quick bus rental bookings in Pune with Amruta Travels. Our efficient service ensures you get the right bus with minimal effort and maximum comfort."
    },
    {
      "name": "Instant Bus Hire Online Pune",
      "description": "Need a bus on short notice? Amruta Travels offers instant online bus hire services in Pune with prompt confirmation and a reliable fleet of vehicles."
    },
    {
      "name": "Hassle-free Bus Booking Pune",
      "description": "Amruta Travels provides hassle-free bus bookings in Pune with real-time availability, online payment options, and 24/7 support for all your travel plans."
    },
    {
      "name": "Convenient Bus Hire Service Pune",
      "description": "Book a bus with convenience through Amruta Travels. Our online service in Pune offers flexibility, affordability, and high-quality vehicles for every journey."
    },
    {
      "name": "Online Luxury Bus Hire Pune",
      "description": "Travel in style with Amruta Travels’ online luxury bus hire services in Pune. Ideal for weddings, VIP transport, or premium travel experiences with AC and plush seating."
    },
    {
      "name": "Online AC Bus Rental Pune",
      "description": "Stay cool and comfortable with AC bus rentals in Pune from Amruta Travels. Our online booking system makes reserving an air-conditioned bus quick and simple."
    },
    {
      "name": "Online Non-AC Bus Hire Pune",
      "description": "Looking for budget-friendly transport? Amruta Travels offers non-AC bus hire in Pune with a straightforward online booking process and reliable service."
    },
    {
      "name": "Online Mini Bus Hire Pune",
      "description": "Need a smaller vehicle? Hire a mini bus online in Pune from Amruta Travels, perfect for short trips, office transfers, or small group travel."
    },
    {
      "name": "Hire 25 Seater Bus On Online Pune",
      "description": "Book a 25-seater bus online in Pune with Amruta Travels for family events, school outings, and corporate use. Enjoy a comfortable ride with professional service."
    },
    {
      "name": "Hire 32 Seater Bus On Online Pune",
      "description": "Amruta Travels provides 32-seater bus hire services online in Pune, ideal for mid-sized group travel, picnics, and intercity journeys with comfortable seating."
    },
    {
      "name": "Hire 40 Seater Bus On Online Pune",
      "description": "Need a large vehicle for group travel? Book a 40-seater bus online in Pune from Amruta Travels and travel in comfort and convenience."
    },
    {
      "name": "Hire 45 Seater Bus On Online Pune",
      "description": "Amruta Travels offers 45-seater bus hire online in Pune for large groups, company events, and tours. Book easily with fast confirmation and reliable service."
    },
    {
      "name": "Hire 50 Seater Bus On Online Pune",
      "description": "Travel in a spacious 50-seater bus with Amruta Travels. Book online in Pune for school trips, events, or pilgrimage tours with air-conditioned comfort."
    },
    {
      "name": "Volvo Sleeper Bus Rent On Rent Online Book",
      "description": "Book Volvo sleeper buses online with Amruta Travels for overnight journeys and long-distance tours from Pune. Enjoy luxury, AC comfort, and peaceful travel."
    }
  ],
  "tableData": [
    ["Pune Bus Hire Online Booking for Outstation", "Online Bus Rental Pune"],
    ["Hire a Bus Online Pune", "Online Bus Booking Pune"],
    ["Bus Rental Booking Pune", "Easy Bus Hire Online Pune"],
    ["Quick Bus Rental Booking Pune", "Instant Bus Hire Online Pune"],
    ["Hassle-free Bus Booking Pune", "Convenient Bus Hire Service Pune"],
    ["Online Luxury Bus Hire Pune", "Online AC Bus Rental Pune"],
    ["Online Non-AC Bus Hire Pune", "Online Mini Bus Hire Pune"],
    ["Hire 25 Seater Bus On Online Pune", "Hire 32 Seater Bus On Online Pune"],
    ["Hire 40 Seater Bus On Online Pune", "Hire 45 Seater Bus On Online Pune"],
    ["Hire 50 Seater Bus On Online Pune", "Volvo Sleeper Bus Rent On Rent Online Book"]
  ],





"whychoose": [
  {
    "WhyChooseheading": "Convenient Online Bus Hire Booking in Pune",
    "WhyChoosedescription": "Amruta Travels offers a seamless online booking service for bus rentals in Pune. With just a few clicks, you can book a luxury bus for your corporate events, weddings, or group outings. Our user-friendly website and mobile interface ensure that booking a bus is quick, easy, and hassle-free, providing you with a convenient solution for all your travel needs."
  },
  {
    "WhyChooseheading": "Instant Confirmation and Secure Payment Options",
    "WhyChoosedescription": "Our online bus hire service provides instant booking confirmation, ensuring your travel plans are set without delay. We offer secure payment gateways for your peace of mind, accepting various payment methods including credit/debit cards, net banking, and digital wallets. Enjoy a safe and smooth transaction process from start to finish."
  },
  {
    "WhyChooseheading": "Wide Range of Buses for Different Needs",
    "WhyChoosedescription": "Whether you're looking for a small minibus for a family trip or a large luxury coach for a corporate event, Amruta Travels offers a wide range of buses for hire. Our fleet includes Bharatbenz buses and other premium options to match your group size and travel requirements, ensuring you have the best ride for your occasion."
  },
  {
    "WhyChooseheading": "Easy and Quick Online Customer Support",
    "WhyChoosedescription": "Amruta Travels provides 24/7 online customer support to assist you with any booking queries or last-minute changes. Our friendly and knowledgeable team is always available to answer questions about bus availability, routes, or services, ensuring a smooth experience throughout the booking process."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for Online Bookings",
    "WhyChoosedescription": "We provide clear and affordable pricing for all our bus hire services booked online. Our rates are competitive and transparent, with no hidden charges. The price you see is the price you pay, covering fuel, tolls, taxes, and driver allowances. Enjoy the convenience of online booking without worrying about extra costs."
  },
  {
    "WhyChooseheading": "Flexible Booking and Easy Cancellation Policies",
    "WhyChoosedescription": "With Amruta Travels, you can easily modify your booking online, ensuring maximum flexibility for your plans. Our hassle-free cancellation policy allows you to make changes or cancel your booking without stress. We understand that plans can change, so we offer you the flexibility to adjust your trip as needed."
  },
  {
    "WhyChooseheading": "Efficient Bus Hire for Corporate and Event Travel",
    "WhyChoosedescription": "Our online bus hire service is ideal for corporate groups, conferences, weddings, and large family gatherings. With just a few clicks, you can book buses equipped with all the amenities for a comfortable and efficient journey. Make your group travel arrangements simpler and faster with our online booking platform."
  },
  {
    "WhyChooseheading": "Reliable and Timely Bus Services",
    "WhyChoosedescription": "Amruta Travels is known for its reliability and punctuality. When you book online, you can trust that your bus will arrive on time and get you to your destination promptly. We prioritize your time and comfort, ensuring a smooth and timely travel experience, no matter where you need to go."
  }
]

















    }

const faqData = [
  {
    question: 'Can I book a bus online for hire in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers an easy and convenient online booking service for bus rentals in Pune. You can quickly reserve a Bharatbenz bus for your desired trip through our website, ensuring a smooth and hassle-free experience.',
  },
  {
    question: 'What types of buses can I book online for hire in Pune?',
    answer: 'Amruta Travels provides a variety of Bharatbenz buses with seating capacities of 32, 35, 40, and 50 seats. You can easily choose the bus that suits your group size and travel needs through our online booking service.',
  },
  {
    question: 'How do I book a bus online for local or outstation trips?',
    answer: 'To book a bus online, visit our website, select your trip type (local or outstation), choose your preferred bus, and provide the necessary details. Our team will confirm your booking as soon as it’s processed.',
  },
  {
    question: 'Is it safe to book a bus online for travel?',
    answer: 'Yes, booking a bus online with Amruta Travels is 100% secure. We ensure your payment information is protected and your booking is processed promptly to guarantee a smooth travel experience.',
  },
  {
    question: 'Can I book a Bharatbenz bus for corporate or private events through online booking?',
    answer: 'Yes, Amruta Travels offers online booking for both corporate events and private functions, such as weddings, family gatherings, and group tours. Our Bharatbenz buses are ideal for any special occasion.',
  },
  {
    question: 'Are the buses sanitized and well-maintained when booked online?',
    answer: 'Yes, all buses booked online are thoroughly sanitized and maintained to meet the highest hygiene and safety standards, ensuring a comfortable and secure journey for all passengers.',
  },
  {
    question: 'How do I get a customized quote for bus rental online in Pune?',
    answer: 'You can easily get a personalized quote by submitting your travel details through the online booking form on our website. We will provide a tailored price based on the trip duration, distance, and additional services you require.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sameer Rathi',
    role: 'Corporate Manager, Pune',
    text: 'I booked a Bharatbenz bus for our corporate retreat through Amruta Travels’ online service. The process was seamless, and the bus was punctual, comfortable, and clean. Excellent service overall!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Priya Joshi',
    role: 'Event Planner',
    text: 'The online booking for a Bharatbenz bus was easy, and the vehicle was perfect for transporting our wedding guests. The bus was spacious, on time, and very comfortable. Highly recommend Amruta Travels!',
    rating: 5,
  },
];








































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Bus Hire Online Booking Service",
  "image": "https://bushireinpune.com/assets/images/pune-bus-hire-online-booking.jpg",
  "description": "Easily book buses online for various purposes including outstation trips, picnics, corporate outings, and weddings in Pune. Choose from luxury, AC, non-AC, or mini buses with seating options from 25 to 50 passengers. Fast and hassle-free booking process.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999",  // Adjust price based on service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-bus-hire-online-booking"
  }
};



    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Pune Bus Hire Online Booking Service | Instant Bus Rental Booking | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book buses online in Pune for outstation, picnics, corporate events, and weddings. Choose from luxury AC or non-AC buses, mini buses, and more. Hassle-free and convenient online booking for all types of buses." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/67.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punebushireonlinebooking;